import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { withRouter } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";
import BaseInput from "../../../../../toolkit/baseInput";
import { handleRequestError } from "../../../../../utils/helpers";
import {
  infoNotification,
  successNotification
} from "../../../../../utils/notifications";
import { applyDirectMembershipTypeChange } from "../../../../actions/partners";
import { Partner } from "./../../interfaces";
import s from "./../../tabStyles.scss";

interface Props {
  partner: Partner;
  refreshPartner: () => void;
  directMembershipList: any[];
}

interface State {
  selectedMembershipId: any;
}

class DirectMembershipChange extends React.Component<Props, State> {
  state = {
    selectedMembershipId: null
  };

  handleChange = () => {
    const { partner } = this.props;
    const { idMembresiaSocio } = partner;
    const { selectedMembershipId } = this.state;

    if (!idMembresiaSocio || !selectedMembershipId) {
      return;
    }

    infoNotification("Actualizando tipo de membresía...");

    applyDirectMembershipTypeChange(idMembresiaSocio, selectedMembershipId)
      .then(() => {
        successNotification("Tipo de membresía actualizado correctamente");
        if (this.props.refreshPartner) {
          this.props.refreshPartner();
        }
      })
      .catch(handleRequestError);
  };

  render() {
    return (
      <React.Fragment>
        <div>
          <div className="row mt-3 mb-3">
            <div className="col">
              <p className={`${s.primaryTitle} w-100 m-0`}>
                Cambio tipo de membresía
              </p>
            </div>
          </div>
          <Row className="row mt-3 mb-3">
            <Col sm={8}>
              <BaseInput
                label="Plan"
                name="directMaintenanceSelector"
                id="directMaintenanceSelector"
                type="select"
                value={this.state.selectedMembershipId}
                onChange={e => {
                  e.preventDefault();
                  const value = e.target.value;
                  this.setState({ selectedMembershipId: value || null });
                }}
                options={[
                  { value: "", label: "Seleccionar tipo de membresía" }
                ].concat(
                  (this.props.directMembershipList || []).map(option => ({
                    value: option.datosBasicosMembresiaId,
                    label: `${option.nombre}`
                  }))
                )}
              />
            </Col>
            <Col className="pl-0 mt-4" sm={4}>
              <Button
                onClick={this.handleChange}
                disabled={!this.state.selectedMembershipId}
              >
                Aplicar cambio
              </Button>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(withStyles(s)(DirectMembershipChange));
